import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../images/img_4.png';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'HeaderView',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();

    // 使用计算属性动态绑定激活状态
    const activeIndex = computed(() => route.path);
    const handleSelect = key => {
      router.push(key);
    };
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        onSelect: handleSelect,
        "text-color": "rgb(13,85,125)",
        "active-text-color": "rgb(13,85,125)"
      }, {
        default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_0,
          class: "nav-logo-img"
        }, null, -1)), _createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("span", {
            class: "logo"
          }, " Cyclostratigraphy Database ", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Home", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/data"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Data", -1)])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/contact"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("span", {
            class: "menuItem"
          }, "Contact", -1)])),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])]);
    };
  }
};